export function isDiscernableObject(a: unknown): a is { kind: unknown } {
  return !!(a && typeof a === 'object' && 'kind' in a);
}
